import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import SEO from '../../components/SEO';

export default function LeistungenPage() {
  const [showBackToTop, setShowBackToTop] = useState(false);
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

  useState(() => {
    const handleScroll = () => setShowBackToTop(window.scrollY > 400);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#gebaeudereinigung`,
          name: 'Gebäudereinigung Ratingen',
          description: 'Professionelle Unterhaltsreinigung, Grundreinigung und Büroreinigung für makellose Sauberkeit in gewerblichen und privaten Räumlichkeiten.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
            address: {
              '@type': 'PostalAddress',
              streetAddress: 'Industriestr. 37',
              addressLocality: 'Ratingen',
              postalCode: '40878',
              addressCountry: 'DE',
            },
          },
          areaServed: 'Ratingen',
          serviceType: 'Gebäudereinigung',
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#fensterreinigung`,
          name: 'Fensterreinigung Ratingen',
          description: 'Streifenfreie Glas- und Fensterreinigung für klaren Durchblick in Ihren Räumen.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
          },
          areaServed: 'Ratingen',
          serviceType: 'Fensterreinigung',
        },
      },
      {
        '@type': 'ListItem',
        position: 3,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#winterdienst`,
          name: 'Winterdienst Ratingen',
          description: 'Zuverlässiger Räum- und Streudienst für sichere Wege und Zufahrten im Winter.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
          },
          areaServed: 'Ratingen',
          serviceType: 'Winterdienst',
        },
      },
      {
        '@type': 'ListItem',
        position: 4,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#umzugsreinigung`,
          name: 'Umzugsreinigung Ratingen',
          description: 'Gründliche End- und Endreinigung für einen reibungslosen Wohnungswechsel.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
          },
          areaServed: 'Ratingen',
          serviceType: 'Umzugsreinigung',
        },
      },
      {
        '@type': 'ListItem',
        position: 5,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#treppenhaus`,
          name: 'Treppenhausreinigung Ratingen',
          description: 'Regelmäßige und gründliche Reinigung von Treppenhäusern in Mehrfamilienhäusern.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
          },
          areaServed: 'Ratingen',
          serviceType: 'Treppenhausreinigung',
        },
      },
      {
        '@type': 'ListItem',
        position: 6,
        item: {
          '@type': 'Service',
          '@id': `${siteUrl}/leistungen#sonderreinigung`,
          name: 'Sonderreinigung Ratingen',
          description: 'Spezielle Reinigungsarbeiten nach Bedarf für außergewöhnliche Anforderungen.',
          provider: {
            '@type': 'LocalBusiness',
            name: 'IGM Facility Service',
          },
          areaServed: 'Ratingen',
          serviceType: 'Sonderreinigung',
        },
      },
    ],
  };

  const services = [
    {
      title: 'Gebäudereinigung',
      image: 'https://public.readdy.ai/ai/img_res/bb127fb443cce3da853d51dc1071c2a1.jpg',
      description: 'Professionelle Reinigungsdienstleistungen für Büros, Gewerbeimmobilien und öffentliche Einrichtungen.',
      features: [
        'Büroreinigung – Tägliche oder wöchentliche Reinigung Ihrer Büroräume',
        'Unterhaltsreinigung – Regelmäßige Pflege aller Räumlichkeiten',
        'Grundreinigung – Intensive Tiefenreinigung nach Bedarf',
        'Treppenhaus- und Flurreinigung',
        'Sanitärreinigung mit Hygiene-Garantie',
        'Müllentsorgung und Recycling-Management'
      ]
    },
    {
      title: 'Hausmeisterservice',
      image: 'https://readdy.ai/api/search-image?query=professional%20facility%20maintenance%20technician%20performing%20building%20repairs%20and%20maintenance%20work%2C%20modern%20residential%20building%20exterior%2C%20tools%20and%20equipment%2C%20clean%20white%20background%2C%20professional%20service%20atmosphere&width=800&height=600&seq=leistungen-hausmeister-1&orientation=landscape',
      description: 'Zuverlässiger Hausmeisterservice für Wohn- und Gewerbeimmobilien.',
      features: [
        'Wartung und Instandhaltung – Regelmäßige Kontrollen und Pflege',
        'Kleinreparaturen – Schnelle Behebung von Schäden',
        'Grünpflege – Rasenmähen, Heckenschnitt, Beetpflege',
        'Winterdienst – Schneeräumung und Streudienst',
        'Hausordnungskontrolle',
        'Beleuchtungswartung und Glühbirnenwechsel'
      ]
    },
    {
      title: 'Schlüsseldienst',
      image: 'https://readdy.ai/api/search-image?query=professional%20locksmith%20service%20technician%20opening%20door%20lock%20with%20specialized%20tools%2C%20modern%20residential%20door%2C%20emergency%20service%20concept%2C%20clean%20white%20color%20scheme%2C%20trustworthy%20professional%20atmosphere&width=800&height=600&seq=leistungen-schluessel-1&orientation=landscape',
      description: '24/7 Notdienst für Türöffnungen und Sicherheitstechnik. Schnell, zuverlässig und zu fairen Festpreisen.',
      features: [
        'Türöffnung ohne Beschädigung – Professionell und schonend',
        'Schlossaustausch – Moderne Sicherheitstechnik',
        'Sicherheitsberatung – Einbruchschutz für Ihr Zuhause',
        'Notdienst 24/7 – Wir sind immer für Sie da',
        'Festpreise – Transparente Kosten ohne versteckte Gebühren',
        'Schließanlagen für Mehrfamilienhäuser'
      ]
    },
    {
      title: 'Fenster- & Glasreinigung',
      image: 'https://readdy.ai/api/search-image?query=professional%20window%20cleaning%20service%20on%20modern%20glass%20building%20facade%2C%20crystal%20clear%20windows%20reflecting%20sky%2C%20cleaning%20equipment%20and%20squeegees%2C%20minimalist%20clean%20aesthetic%20with%20white%20colors&width=800&height=600&seq=leistungen-fenster-1&orientation=landscape',
      description: 'Streifenfreie Fenster- und Glasreinigung für Privat- und Geschäftskunden.',
      features: [
        'Fensterreinigung innen und außen',
        'Rahmen- und Fensterbankpflege',
        'Glasfassadenreinigung',
        'Wintergartenreinigung',
        'Schaufensterreinigung für Geschäfte',
        'Höhenarbeiten mit professioneller Ausrüstung'
      ]
    },
    {
      title: 'Sonderreinigung',
      image: 'https://readdy.ai/api/search-image?query=specialized%20deep%20cleaning%20service%20for%20industrial%20and%20commercial%20spaces%2C%20professional%20cleaning%20equipment%20and%20machinery%2C%20modern%20facility%20interior%2C%20thorough%20sanitation%20process%2C%20clean%20white%20professional%20atmosphere&width=800&height=600&seq=leistungen-sonder-1&orientation=landscape',
      description: 'Spezielle Reinigungsdienstleistungen für besondere Anforderungen.',
      features: [
        'Baureinigung nach Renovierungen',
        'Tatortreinigung und Desinfektion',
        'Teppich- und Polsterreinigung',
        'Industriereinigung',
        'Veranstaltungsreinigung',
        'Desinfektion und Hygiene-Service'
      ]
    },
    {
      title: 'Umzugsreinigung',
      image: 'https://readdy.ai/api/search-image?query=professional%20move-out%20cleaning%20service%20in%20empty%20apartment%2C%20spotless%20clean%20rooms%20ready%20for%20handover%2C%20cleaning%20supplies%20and%20equipment%2C%20bright%20natural%20lighting%2C%20fresh%20clean%20white%20atmosphere&width=800&height=600&seq=leistungen-umzug-1&orientation=landscape',
      description: 'Professionelle Endreinigung für Wohnungen und Häuser.',
      features: [
        'Endreinigung nach Auszug',
        'Grundreinigung vor Einzug',
        'Küchen- und Badreinigung',
        'Fensterreinigung inklusive',
        'Balkon- und Terrassenreinigung',
        'Abnahmegarantie für Vermieter'
      ]
    }
  ];

  const processSteps = [
    { number: '01', title: 'Anfrage', description: 'Kontaktieren Sie uns telefonisch, per E-Mail oder über unser Kontaktformular', icon: 'ri-phone-line' },
    { number: '02', title: 'Angebot', description: 'Wir erstellen Ihnen ein individuelles, kostenloses und unverbindliches Angebot', icon: 'ri-file-text-line' },
    { number: '03', title: 'Auftrag', description: 'Nach Ihrer Zusage vereinbaren wir einen passenden Termin für die Durchführung', icon: 'ri-calendar-check-line' },
    { number: '04', title: 'Erledigt', description: 'Unser professionelles Team führt die Arbeiten zuverlässig und gründlich aus', icon: 'ri-checkbox-circle-line' }
  ];

  const pricingTiers = [
    {
      name: 'Basic', price: 'Auf Anfrage', description: 'Ideal für kleine Büros und Privathaushalte',
      features: ['Wöchentliche Reinigung', 'Grundreinigung aller Räume', 'Sanitärreinigung', 'Müllentsorgung', 'Flexible Terminvereinbarung', 'Zufriedenheitsgarantie'],
      highlighted: false
    },
    {
      name: 'Professional', price: 'Auf Anfrage', description: 'Perfekt für mittelständische Unternehmen',
      features: ['Tägliche Reinigung', 'Unterhalts- und Grundreinigung', 'Fensterreinigung monatlich', 'Treppenhaus- und Flurreinigung', 'Grünpflege', 'Persönlicher Ansprechpartner', 'Notfall-Hotline', '100% Zufriedenheitsgarantie'],
      highlighted: true
    },
    {
      name: 'Premium', price: 'Auf Anfrage', description: 'Rundum-Sorglos-Paket für große Objekte',
      features: ['Individuelle Reinigungsintervalle', 'Komplette Objektbetreuung', 'Hausmeisterservice inklusive', 'Winterdienst', 'Sonderreinigungen', 'Schlüsseldienst-Bereitschaft', '24/7 Notfall-Hotline', 'Dediziertes Service-Team', 'Qualitätskontrollen'],
      highlighted: false
    }
  ];

  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <SEO
        title="Leistungen | Gebäudereinigung & Facility Service Ratingen | IGM"
        description="Alle Leistungen von IGM Facility Service Ratingen: Gebäudereinigung, Fensterreinigung, Winterdienst, Umzugsreinigung, Treppenhausreinigung und Sonderreinigung. Jetzt informieren!"
        keywords="Gebäudereinigung, Fensterreinigung, Winterdienst, Umzugsreinigung, Treppenhausreinigung, Sonderreinigung, Ratingen"
        canonical="/leistungen"
        jsonLd={jsonLd}
      />
      <Header />

      {/* Hero Banner */}
      <section className="relative pt-32 pb-20 bg-[#0D2B4E]">
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
        <div className="container mx-auto px-6 relative z-10">
          <nav className="flex items-center gap-2 text-xs sm:text-sm text-white/70 mb-6">
            <Link to="/" className="hover:text-white transition-colors cursor-pointer">Startseite</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-white">Leistungen</span>
          </nav>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 sm:mb-6">Unsere Leistungen</h1>
          <p className="text-base sm:text-lg md:text-xl text-white/80 max-w-2xl">
            Professionelle Dienstleistungen für Gebäudereinigung, Hausmeisterservice und Schlüsseldienst – alles aus einer Hand.
          </p>
        </div>
      </section>

      {/* Services Detail Sections */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="space-y-16 sm:space-y-20 md:space-y-24">
            {services.map((service, index) => (
              <div key={index} className="flex flex-col gap-8 sm:gap-10 md:gap-12 items-center">
                <div className="w-full">
                  <div className="relative overflow-hidden rounded-2xl shadow-2xl group">
                    <img src={service.image} alt={service.title} className="w-full h-[250px] sm:h-[350px] md:h-[400px] object-cover transition-transform duration-500 group-hover:scale-110" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
                  </div>
                </div>
                <div className="w-full">
                  <div className="inline-block px-4 py-2 bg-[#0D2B4E]/10 text-[#0D2B4E] rounded-full text-sm font-semibold mb-4">
                    Service {index + 1}
                  </div>
                  <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4 sm:mb-6">{service.title}</h2>
                  <p className="text-base sm:text-lg text-gray-600 mb-6 sm:mb-8 leading-relaxed">{service.description}</p>
                  <ul className="space-y-3 sm:space-y-4">
                    {service.features.map((feature, fIndex) => (
                      <li key={fIndex} className="flex items-start gap-3">
                        <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-0.5">
                          <i className="ri-checkbox-circle-fill text-xl text-[#0D2B4E]"></i>
                        </div>
                        <span className="text-gray-700 text-sm sm:text-base">{feature}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Steps Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">So funktioniert's</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">In vier einfachen Schritten zu Ihrem sauberen und gepflegten Objekt</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 sm:gap-8">
            {processSteps.map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-6 sm:p-8 shadow-lg hover:shadow-xl transition-shadow h-full">
                  <div className="w-14 h-14 sm:w-16 sm:h-16 flex items-center justify-center bg-[#0D2B4E] rounded-full mb-4 sm:mb-6">
                    <i className={`${step.icon} text-2xl sm:text-3xl text-white`}></i>
                  </div>
                  <div className="text-4xl sm:text-5xl font-bold text-[#0D2B4E]/10 mb-3 sm:mb-4">{step.number}</div>
                  <h3 className="text-xl sm:text-2xl font-bold text-gray-900 mb-3 sm:mb-4">{step.title}</h3>
                  <p className="text-gray-600 text-sm sm:text-base leading-relaxed">{step.description}</p>
                </div>
                {index < processSteps.length - 1 && (
                  <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2 z-10">
                    <i className="ri-arrow-right-line text-3xl text-[#0D2B4E]/30"></i>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Pricing Packages Section */}
      <section className="py-12 sm:py-16 md:py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">Unsere Pakete</h2>
            <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-2xl mx-auto">Wählen Sie das passende Service-Paket für Ihre Bedürfnisse</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 max-w-6xl mx-auto">
            {pricingTiers.map((tier, index) => (
              <div key={index} className={`relative rounded-2xl p-6 sm:p-8 ${tier.highlighted ? 'bg-[#0D2B4E] shadow-2xl md:scale-105' : 'bg-white border-2 border-gray-200 shadow-lg'}`}>
                {tier.highlighted && (
                  <div className="absolute -top-4 left-1/2 transform -translate-x-1/2">
                    <span className="bg-yellow-400 text-gray-900 px-4 py-1 rounded-full text-sm font-bold whitespace-nowrap">Beliebteste Wahl</span>
                  </div>
                )}
                <div className="text-center mb-6 sm:mb-8">
                  <h3 className={`text-xl sm:text-2xl font-bold mb-2 ${tier.highlighted ? 'text-white' : 'text-gray-900'}`}>{tier.name}</h3>
                  <p className={`text-sm mb-4 sm:mb-6 ${tier.highlighted ? 'text-white/70' : 'text-gray-600'}`}>{tier.description}</p>
                  <div className={`text-2xl sm:text-3xl font-bold ${tier.highlighted ? 'text-white' : 'text-[#0D2B4E]'}`}>{tier.price}</div>
                </div>
                <ul className="space-y-3 sm:space-y-4 mb-6 sm:mb-8">
                  {tier.features.map((feature, fIndex) => (
                    <li key={fIndex} className="flex items-start gap-3">
                      <div className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                        <i className={`ri-checkbox-circle-fill text-lg ${tier.highlighted ? 'text-white' : 'text-[#0D2B4E]'}`}></i>
                      </div>
                      <span className={`text-sm ${tier.highlighted ? 'text-white' : 'text-gray-700'}`}>{feature}</span>
                    </li>
                  ))}
                </ul>
                <Link to="/kontakt" className={`block w-full text-center py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${tier.highlighted ? 'bg-white text-[#0D2B4E] hover:bg-gray-100' : 'bg-[#0D2B4E] text-white hover:bg-[#0a2240]'}`}>
                  Angebot anfragen
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Bottom CTA Banner */}
      <section className="py-12 sm:py-16 md:py-20 bg-[#0D2B4E] relative overflow-hidden">
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4 sm:mb-6">Bereit für professionellen Service?</h2>
            <p className="text-base sm:text-lg md:text-xl text-white/70 mb-8 sm:mb-10">Kontaktieren Sie uns jetzt für ein kostenloses und unverbindliches Angebot.</p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Link to="/kontakt" className="inline-flex items-center justify-center gap-2 bg-white text-[#0D2B4E] px-8 py-4 rounded-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-mail-line text-xl"></i>
                <span>Jetzt Angebot anfragen</span>
              </Link>
              <a href="tel:+492102739807" className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/30 text-white px-8 py-4 rounded-lg font-semibold hover:bg-white/20 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-phone-fill text-xl"></i>
                <span>02102 / 7398070</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <Footer />

      <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className="fixed bottom-4 right-4 w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center bg-[#0D2B4E] text-white rounded-full shadow-lg hover:bg-[#0a2240] transition-all hover:scale-110 z-40 cursor-pointer">
        <i className="ri-arrow-up-line text-lg sm:text-xl"></i>
      </button>
    </div>
  );
}